import axios from 'axios'
// import { apiUrl } from '@/api/base.js'
import qs from 'qs'

export default {
    getNewsList(limit,type,page){
        // return axios.get('/api/newsList',{params:{limit:5,newsType:type,page:page}})
        // -------------------------------------------------------新增----------------------------------------
        return axios.get('/api/newsList',{params:{limit:limit,newsType:type,page:page}})
    },

    getNewsDetail(id,type){
        return axios.get('/api/newsDetail',{params:{newsId:id,newsType:type}})
    },

    // getQueryNewsList(query){
    //     return axios.get('/api/newsList',{params: query })
    // },

    getNewsImg(img){
        // 不需要判断了 这个nginx解决了
        // let basePath = process.env.NODE_ENV === 'production' ? '' : '/else'
        return axios.get('/else'+img,{ responseType: 'blob' })
    },

    postUs(email,msg,phone,name){
        // return axios.post('/api/contactInfoSubmit',{data:{email:email,message:msg,phone:phone,userName:name}})
        return axios.post('/api/contactInfoSubmit',qs.stringify({email:email,message:msg,phone:phone,userName:name}))
    }

};

